import { useSelector, useDispatch } from 'react-redux';
//STATE ACTIONS
import { setSettings } from '../../redux/action/toolpage/action';
export default function TypesFilter() {
  //STATE
  const avatarTool = useSelector((state) => state.avatarTool);
  const dispatch = useDispatch();

  //SET ANIMATIONS
  const setAnimations = (animation) =>{
    let Details = {
      animationType : animation,
      model : avatarTool?.settings?.model
    };
    dispatch(setSettings(Details));   
  };
  return (
    <div className="collection_filter_set">
      <div className="search_container">
        <div className="search_field">
          <svg
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="search-field__icon"
          >
            <path
              d="M19.5348 18.4655L15.4754 14.4155C16.9081 12.7098 17.627 10.5169 17.4821 8.29403C17.3372 6.07118 16.3398 3.99008 14.6979 2.48476C13.0559 0.979436 10.8962 0.16612 8.66915 0.214438C6.44211 0.262757 4.31971 1.16898 2.74459 2.7441C1.16947 4.31922 0.263245 6.44163 0.214927 8.66866C0.166608 10.8957 0.979924 13.0554 2.48525 14.6974C3.99057 16.3393 6.07167 17.3367 8.29452 17.4816C10.5174 17.6265 12.7103 16.9076 14.416 15.4749L18.466 19.5343C18.6094 19.6729 18.801 19.7504 19.0004 19.7504C19.1998 19.7504 19.3914 19.6729 19.5348 19.5343C19.6756 19.3921 19.7546 19.2 19.7546 18.9999C19.7546 18.7998 19.6756 18.6077 19.5348 18.4655ZM1.75039 8.8749C1.75039 7.46571 2.16826 6.08816 2.95117 4.91646C3.73407 3.74476 4.84685 2.83153 6.14877 2.29226C7.45069 1.75298 8.88329 1.61189 10.2654 1.88681C11.6475 2.16173 12.9171 2.84032 13.9135 3.83676C14.91 4.83321 15.5886 6.10277 15.8635 7.48488C16.1384 8.867 15.9973 10.2996 15.458 11.6015C14.9188 12.9034 14.0055 14.0162 12.8338 14.7991C11.6621 15.582 10.2846 15.9999 8.87539 15.9999C6.98648 15.9974 5.17565 15.246 3.83999 13.9103C2.50433 12.5746 1.75287 10.7638 1.75039 8.8749Z"
              fill="white"
            ></path>
          </svg>
          <input className="" placeholder="Search for.." type="text" />
        </div>
      </div>
      <button className="button_container button_icon_square filter_button">
        <svg
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="button_icon_square_icon"
        >
          <path
            d="M10.625 9.375V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V9.375C9.375 9.20924 9.44085 9.05027 9.55806 8.93306C9.67527 8.81585 9.83424 8.75 10 8.75C10.1658 8.75 10.3247 8.81585 10.4419 8.93306C10.5592 9.05027 10.625 9.20924 10.625 9.375ZM15.625 15C15.4592 15 15.3003 15.0658 15.1831 15.1831C15.0658 15.3003 15 15.4592 15 15.625V16.875C15 17.0408 15.0658 17.1997 15.1831 17.3169C15.3003 17.4342 15.4592 17.5 15.625 17.5C15.7908 17.5 15.9497 17.4342 16.0669 17.3169C16.1842 17.1997 16.25 17.0408 16.25 16.875V15.625C16.25 15.4592 16.1842 15.3003 16.0669 15.1831C15.9497 15.0658 15.7908 15 15.625 15ZM17.5 12.5H16.25V3.125C16.25 2.95924 16.1842 2.80027 16.0669 2.68306C15.9497 2.56585 15.7908 2.5 15.625 2.5C15.4592 2.5 15.3003 2.56585 15.1831 2.68306C15.0658 2.80027 15 2.95924 15 3.125V12.5H13.75C13.5842 12.5 13.4253 12.5658 13.3081 12.6831C13.1908 12.8003 13.125 12.9592 13.125 13.125C13.125 13.2908 13.1908 13.4497 13.3081 13.5669C13.4253 13.6842 13.5842 13.75 13.75 13.75H17.5C17.6658 13.75 17.8247 13.6842 17.9419 13.5669C18.0592 13.4497 18.125 13.2908 18.125 13.125C18.125 12.9592 18.0592 12.8003 17.9419 12.6831C17.8247 12.5658 17.6658 12.5 17.5 12.5ZM4.375 12.5C4.20924 12.5 4.05027 12.5658 3.93306 12.6831C3.81585 12.8003 3.75 12.9592 3.75 13.125V16.875C3.75 17.0408 3.81585 17.1997 3.93306 17.3169C4.05027 17.4342 4.20924 17.5 4.375 17.5C4.54076 17.5 4.69973 17.4342 4.81694 17.3169C4.93415 17.1997 5 17.0408 5 16.875V13.125C5 12.9592 4.93415 12.8003 4.81694 12.6831C4.69973 12.5658 4.54076 12.5 4.375 12.5ZM6.25 10H5V3.125C5 2.95924 4.93415 2.80027 4.81694 2.68306C4.69973 2.56585 4.54076 2.5 4.375 2.5C4.20924 2.5 4.05027 2.56585 3.93306 2.68306C3.81585 2.80027 3.75 2.95924 3.75 3.125V10H2.5C2.33424 10 2.17527 10.0658 2.05806 10.1831C1.94085 10.3003 1.875 10.4592 1.875 10.625C1.875 10.7908 1.94085 10.9497 2.05806 11.0669C2.17527 11.1842 2.33424 11.25 2.5 11.25H6.25C6.41576 11.25 6.57473 11.1842 6.69194 11.0669C6.80915 10.9497 6.875 10.7908 6.875 10.625C6.875 10.4592 6.80915 10.3003 6.69194 10.1831C6.57473 10.0658 6.41576 10 6.25 10ZM11.875 6.25H10.625V3.125C10.625 2.95924 10.5592 2.80027 10.4419 2.68306C10.3247 2.56585 10.1658 2.5 10 2.5C9.83424 2.5 9.67527 2.56585 9.55806 2.68306C9.44085 2.80027 9.375 2.95924 9.375 3.125V6.25H8.125C7.95924 6.25 7.80027 6.31585 7.68306 6.43306C7.56585 6.55027 7.5 6.70924 7.5 6.875C7.5 7.04076 7.56585 7.19973 7.68306 7.31694C7.80027 7.43415 7.95924 7.5 8.125 7.5H11.875C12.0408 7.5 12.1997 7.43415 12.3169 7.31694C12.4342 7.19973 12.5 7.04076 12.5 6.875C12.5 6.70924 12.4342 6.55027 12.3169 6.43306C12.1997 6.31585 12.0408 6.25 11.875 6.25Z"
            fill="white"
          ></path>
        </svg>
      </button>
      {/* <button
        className="button_container button_icon_square filter_button display_anim_btn"
        id="dropdownMenuAvatarAnim"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
      >
        <svg
          width="15"
          height="22"
          viewBox="0 0 15 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="animate"
        >
          <path
            d="M6.99686 14.9051L7.34113 14.8304L7.15927 13.2447H7.56227V15.0853H7.85489V15.864L7.22543 16.3857L6.99686 14.9051ZM6.35715 0L6.30089 0.610207L5.60917 0.601712L5.41562 2.55798L5.28188 4.33445L5.68312 4.35285V5.02182L6.58289 5.58813L6.56909 6.1003L5.44888 6.09676L3.2198 5.34462L3.22439 5.53398L2.84616 5.37258L2.15408 2.71443L2.64306 2.55303L2.23263 1.11317L1.21326 1.12272L0 1.49154L0.424588 3.04183L0.61813 3.06944L1.50269 6.27196L4.56999 7.31929V8.45936H5.28966L5.30169 9.85038L5.30735 11.1352V11.4725H4.98891L5.05579 12.7977L4.83217 12.8773L5.56635 16.5071L5.38944 16.5283L5.56635 18.0786L5.56211 18.0814L5.63853 18.732H5.64243L5.96936 18.6842L6.07551 19.9744L6.08577 20.0968L6.09178 20.1043L6.16715 20.712L6.32672 20.707L6.59244 22L7.7314 21.7876L8.33785 20.9948L8.14644 20.1807L7.93909 20.2076L7.88036 19.9467H7.70345L7.43207 18.2754L9.48424 16.7665L9.221 16.5032H9.63568V15.081H9.82356L9.78818 12.2547H9.49415V11.137H9.03099V9.96895L9.0409 8.72164L9.78818 8.78605L9.82356 7.8357L12.9415 7.49414L14.1682 5.06712L14.3451 5.09473L14.4834 4.76237L14.6218 4.80839L15 4.00563L14.0224 3.44356L13.5978 3.42516L13.487 3.61877L13.2394 3.54479L12.8601 4.40311L13.1184 4.6707L12.1864 6.59016L11.4207 6.70095V6.47937L9.70503 6.62697L9.68663 6.46097L8.24763 6.33178L8.26709 5.82669L9.2447 5.92828L9.47858 5.70104L9.93608 5.7598L10.3876 2.7254L10.6642 2.7608L10.9225 0.988931H10.7209V0.628612L8.5091 0H6.35715Z"
            fill="white"
          ></path>
        </svg>
      </button>
      <ul
        className="dropdown-menu dropdown-menu-dark dropdownmenu_custom"
        aria-labelledby="dropdownMenuAvatarAnim"
      >
        
        <li>
          <a
            className="dropdown-item"
            href="#"
            onClick={() => setAnimations("idle")}
          >
            Idle
            {avatarTool.settings.animationType === "idle" ? (
                <svg
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="AvatarAnim_active_icon"
              >
                <path
                  d="M5.31254 9.49998C5.16345 9.49795 5.0205 9.44027 4.91176 9.33826L0.974258 5.40076C0.88456 5.29147 0.838721 5.15272 0.845657 5.0115C0.852593 4.87029 0.911807 4.7367 1.01178 4.63672C1.11176 4.53675 1.24535 4.47753 1.38656 4.4706C1.52778 4.46366 1.66653 4.5095 1.77582 4.5992L5.31254 8.14295L12.7868 0.661698C12.896 0.572 13.0348 0.52616 13.176 0.533096C13.3172 0.540031 13.4508 0.599246 13.5508 0.699222C13.6508 0.799198 13.71 0.932787 13.7169 1.074C13.7239 1.21522 13.678 1.35397 13.5883 1.46326L5.71332 9.33826C5.60458 9.44027 5.46163 9.49795 5.31254 9.49998Z"
                  fill="white"
                ></path>
              </svg>
            ):(null)}
          </a>
        </li>
        <li>
          <a
            className="dropdown-item"
            href="#"
            onClick={() => setAnimations("walk")}
          >
            Walk
            {avatarTool.settings.animationType === "walk" ? (
                <svg
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="AvatarAnim_active_icon"
              >
                <path
                  d="M5.31254 9.49998C5.16345 9.49795 5.0205 9.44027 4.91176 9.33826L0.974258 5.40076C0.88456 5.29147 0.838721 5.15272 0.845657 5.0115C0.852593 4.87029 0.911807 4.7367 1.01178 4.63672C1.11176 4.53675 1.24535 4.47753 1.38656 4.4706C1.52778 4.46366 1.66653 4.5095 1.77582 4.5992L5.31254 8.14295L12.7868 0.661698C12.896 0.572 13.0348 0.52616 13.176 0.533096C13.3172 0.540031 13.4508 0.599246 13.5508 0.699222C13.6508 0.799198 13.71 0.932787 13.7169 1.074C13.7239 1.21522 13.678 1.35397 13.5883 1.46326L5.71332 9.33826C5.60458 9.44027 5.46163 9.49795 5.31254 9.49998Z"
                  fill="white"
                ></path>
              </svg>
            ):(null)}
          </a>
        </li>
      </ul> */}


    </div>
  );
}
